// Garment icons + brand logos + shade colours for the campus order card.
// Icons: src/assets/ICONSS  |  Brand logos: src/assets/brands (MUSTAQBIL se).
import icCoat from "../assets/ICONSS/COAT.png";
import icTrousers from "../assets/ICONSS/trousers.png";
import icShirt from "../assets/ICONSS/shirt.png";
import icTie from "../assets/ICONSS/tie.png";
import icVest from "../assets/ICONSS/vest.png";
import icKurta from "../assets/ICONSS/kurta.png";
import icPajama from "../assets/ICONSS/PAJAMA.png";
import icSadri from "../assets/ICONSS/SADRI.png";

import logoRaymond from "../assets/brands/RAYMOND-01.svg";
import logoSiyaram from "../assets/brands/siyarams-01.svg";
import logoGiza from "../assets/brands/GIZA ELEVE LOGO-011-01.svg";
import logoMaviinci from "../assets/brands/MAVIINCI.svg";

const ICON_BY_TYPE = {
    coat: icCoat, blazer: icCoat, jacket: icCoat,
    pant: icTrousers, pants: icTrousers, trouser: icTrousers, trousers: icTrousers,
    shirt: icShirt,
    tie: icTie,
    vest_coat: icVest, vest: icVest, waistcoat: icVest,
    kurta: icKurta,
    pajama: icPajama, pyjama: icPajama,
    sadri: icSadri,
};

export function garmentIcon(type) {
    const k = String(type || "").trim().toLowerCase();
    return ICON_BY_TYPE[k] || icShirt;
}

const LOGO_BY_BRAND = {
    raymond: logoRaymond,
    "siyaram's": logoSiyaram, siyarams: logoSiyaram, siyaram: logoSiyaram,
    "giza eleve": logoGiza, giza: logoGiza,
    maviinci: logoMaviinci,
};

export function parseFabric(value) {
    const s = String(value || "").trim();
    if (!s) return { brand: "", line: "" };
    const m = s.match(/^(.+?)\s+-\s+(.+)$/);
    if (m) return { brand: m[1].trim(), line: m[2].trim() };
    return { brand: "", line: s };
}

export function brandLogo(brand) {
    const k = String(brand || "").trim().toLowerCase();
    return LOGO_BY_BRAND[k] || null;
}

// Shade name -> a representative swatch colour.
const SHADE_RULES = [
    [/(navy|dark\s*blue|midnight|ink)/, "#1e2a52"],
    [/(sky|powder|light\s*blue)/, "#7db3e8"],
    [/blue/, "#2f5fd0"],
    [/(off.?white|ivory|cream|beige|sand|ecru)/, "#e6dcc4"],
    [/white/, "#f2f2ef"],
    [/(charcoal|graphite)/, "#3a3f45"],
    [/(grey|gray|silver)/, "#8a909a"],
    [/(black|jet)/, "#191b1f"],
    [/(coffee|chocolate|brown|tan|camel)/, "#7a4a24"],
    [/(maroon|wine|cherry|burgundy)/, "#6e1f2e"],
    [/(olive)/, "#5b6b2f"],
    [/green/, "#2f7d46"],
    [/red/, "#c0322c"],
    [/(pink|rose)/, "#e58aa5"],
    [/(purple|violet|lavender)/, "#6d28d9"],
    [/(mustard|yellow|gold)/, "#c9a227"],
    [/orange/, "#d2691e"],
];
export function shadeColor(name) {
    const s = String(name || "").trim().toLowerCase();
    if (!s) return "#c9cdd3";
    for (const [re, hex] of SHADE_RULES) if (re.test(s)) return hex;
    return "#9aa1ad";
}

// One booking -> per-garment display lines for the order card.
export function garmentLines(b) {
    const items = (b && b.active_items) || [];
    return items.map((it) => {
        const isTie = it.type === "tie";
        const raw = isTie ? (b[`${it.id}_color`] || "") : (b[`${it.id}_fabric`] || "");
        const shd = isTie ? "" : (b[`${it.id}_shade`] || "");
        const { brand, line } = parseFabric(raw);
        return {
            id: it.id,
            name: it.name || it.type || "Item",
            icon: garmentIcon(it.type),
            logo: brandLogo(brand),
            brand,
            fabric: line || raw || "",
            shade: shd || (isTie ? raw : ""),
        };
    });
}
